import { FontWeight } from './types';

interface IFontFamily {
  averta: string;
  euclid: string;
}

interface IFontWeight {
  regular: number;
  medium: number;
  semiBold: number;
  bold: number;
}

export interface IFont {
  family: IFontFamily;
  weight: IFontWeight;
}

const FontWeights: IFontWeight = {
  regular: FontWeight.REGULAR,
  medium: FontWeight.MEDIUM,
  semiBold: FontWeight.SEMI_BOLD,
  bold: FontWeight.BOLD,
};

export const Font: IFont = {
  family: {
    averta: 'Averta, serif',
    euclid: 'Euclid Circular A, sans-serif',
  },
  weight: FontWeights,
};
